import { render, staticRenderFns } from "./EstadoSubscricaoPerfil.vue?vue&type=template&id=3b07ab12&scoped=true&"
import script from "./EstadoSubscricaoPerfil.vue?vue&type=script&lang=js&"
export * from "./EstadoSubscricaoPerfil.vue?vue&type=script&lang=js&"
import style0 from "./EstadoSubscricaoPerfil.vue?vue&type=style&index=0&id=3b07ab12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07ab12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
